@if (validToken()) {
  @if (areTradsReady()) {
    <div class="welcome__container">
      <div class="welcome__container__logo">
        <img src="assets/imandat-logo.svg" />
      </div>
      <div class="welcome__container__text">
        <h1 class="welcome__container__text-title">iMandat</h1>
        <h2 class="welcome__container__text-subtitle">
          {{ "LOGIN.SUBTITLE" | translate }}
        </h2>
        <p class="welcome__container__text-description">
          {{ "LOGIN.MESSAGE_START" | translate }}
          <br />
          {{ "LOGIN.MESSAGE_END" | translate }}
        </p>
        <i-button
          [text]="'LOGIN.BUTTON' | translate"
          styleClass="green mt-5"
          icon="bi bi-arrow-right-short"
          (click)="login()"
        ></i-button>
      </div>
    </div>
  } @else {
    <div
      class="w-100 d-flex justify-content-center align-items-center"
      style="margin-top: 10rem"
    >
      <im-loader></im-loader>
    </div>
  }
} @else {
  <div class="welcome__container">
    <div class="welcome__container__logo">
      <img src="assets/imandat-logo.svg" />
    </div>
    <div class="welcome__container__text">
      <h1 class="welcome__container__text-title">iMandat</h1>

      <p>
        {{ "LOGIN.NO_ACCESS" | translate }}
      </p>
      <i-button
        [text]="'LOGIN.DISCONNECT' | translate"
        styleClass="blue mt-5"
        icon="bi bi-box-arrow-right"
        (click)="logout()"
      ></i-button>
    </div>
  </div>
}
